export default function getPxValueFromStringImageUtil (pxStr) {
  const pxValStr = pxStr.slice(0, pxStr.indexOf('em'))
  return parseFloat(pxValStr)
}
